export default __webpack_public_path__ + "static/app-data-deletion-success-b234ba0a79ae80c701a9014c670cab2e.jpg";